<template>
  <div>
    <div>
      <vue-dropzone id="dropzone-gallery"
                    ref="dropzone"
                    class="mb-3"
                    @vdropzone-sending="sendingEvent"
                    @vdropzone-success="moveUploadedFile"
                    :options="dropzoneOptions"></vue-dropzone>
    </div>
    <div class="row">
      <le-loading v-if="isLoading"></le-loading>
      <div class="col-sm-6 offset-sm-3" v-if="!photos.length && !isLoading">
        <h4 class="text-center mt-5 alert alert-warning">
          {{$t('game.no-photos-found')}}
        </h4>
      </div>
      <div v-for="(photo, photoIndex) in photos" :key="photo.uuid" class="col-md-6 col-lg-4 col-xl-2 animated fadeIn mb-4" style="cursor: pointer" @click="editPhoto(photo, photoIndex)">
        <div class="options-container fx-item-rotate-r mb-1">
          <img class="img-fluid options-item" :src="photo.coverUrl" :id="`photo-cover-${photo.uuid}`" alt="">
          <div class="options-overlay bg-black-75">
            <div class="d-flex text-white font-weight-bold">
              {{$tc('tag.add', 2)}}
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button class="btn btn-sm btn-info">
            <i class="fa fa-plus"></i> {{$tc('tag.add', 2)}}
          </button>
          <button class="btn btn-sm btn-danger" @click.stop="deletePhoto(photo, photoIndex)" v-tooltip="$t('tooltip.deletePhoto')">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
    <modal @before-close="modalClosed()" name="tags" :adaptive="true" height="100%" width="100%">
      <div v-if="photoTagsLoading" style="height: 100%" class="position-relative">
        <le-loading></le-loading>
      </div>
      <div v-show="!photoTagsLoading" class="position-relative">
        <div class="d-flex justify-content-between text-right p-2 position-sticky gallery-modal-header">
          <div>
            <button :disabled="this.currentPhotoIndex < 1" @click="prevPhoto()" class="btn btn-sm btn-info mr-2" v-tooltip="$t('tooltip.previousPhoto')"><i class="fa fa-arrow-left"></i></button>
            <button :disabled="this.photos.length - 1 <= this.currentPhotoIndex" @click="nextPhoto()" class="btn btn-sm btn-info" v-tooltip="$t('tooltip.nextPhoto')"><i class="fa fa-arrow-right"></i></button>
          </div>
          <div>
            <button class="btn btn-sm" :class="isHighlighted(currentPhoto) ? 'btn-warning active' : 'btn-outline-warning'" @click.stop="toggleHighlight()" :title="$t ? $t('photo.highlight') : 'Highlight'">
              <i :class="isHighlighted(currentPhoto) ? 'fa fa-star' : 'fa fa-star-o'"></i>
            </button>
            <button class="btn btn-sm btn-light" @click="$modal.hide('tags')" v-tooltip="$t('close')">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div v-if="entityOptions" class="px-4 pb-3">
          <div class="d-flex justify-content-around align-items-center mb-3">
            <button :disabled="rotatePhotoLoading" class="btn btn-info" @click="rotatePhoto('left')" v-tooltip="$t('tooltip.rotateLeft')"><i class="fa fa-undo"></i></button>
            <div class="position-relative">
              <le-loading v-if="rotatePhotoLoading"></le-loading>
              <img class="mw-100" style="max-height: 300px" :src="currentPhoto?.url" :id="`photo-${currentPhoto?.uuid}`" alt="">
            </div>
            <button :disabled="rotatePhotoLoading" class="btn btn-info" @click="rotatePhoto('right')" v-tooltip="$t('tooltip.rotateRight')"><i class="fa fa-undo gallery-rotate-right-icon"></i></button>
          </div>
          <div class="d-flex mb-3 justify-content-center">
            <button class="btn btn-sm" :class="isHighlighted(currentPhoto) ? 'btn-warning active' : 'btn-outline-warning'" @click.stop="toggleHighlight()" :title="$t ? $t('photo.highlight') : 'Highlight'">
              {{$t('showPhotoInGallery')}} <i :class="isHighlighted(currentPhoto) ? 'fa fa-star' : 'fa fa-star-o'"></i>
            </button>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <p class="font-weight-bold mb-2">{{ entityOptions.homeTeam.entity.entityName }}</p>
              <div class="row">
                <div v-for="player in entityOptions.homeTeam.players" :key="player.entity.entityUuid" class="col-lg-6">
                  <le-photo-tag-entity :entity="player.entity" :circle-info="player.jerseyNumber" :is-active="isEntitySelected(player.entity)" :clickable="true" @entityClicked="togglePlayer(player.entity, entityOptions.homeTeam.entity)"></le-photo-tag-entity>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <p class="font-weight-bold mb-2">{{ entityOptions.awayTeam.entity.entityName }}</p>
              <div class="row">
                <div v-for="player in entityOptions.awayTeam.players" :key="player.entity.entityUuid" class="col-lg-6">
                  <le-photo-tag-entity :entity="player.entity" :circle-info="player.jerseyNumber" :is-active="isEntitySelected(player.entity)" :clickable="true" @entityClicked="togglePlayer(player.entity, entityOptions.awayTeam.entity)"></le-photo-tag-entity>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { TokenService } from '@/services/storage.service'
import vue2Dropzone from 'vue2-dropzone'
import PhotoService from '@/services/photo.service'
import LePhotoTagEntity from '@/components/ntm/LePhotoTagEntity.vue'
import LeLoading from '@/components/ntm/LeLoading.vue'

export default {
  components: {
    LeLoading,
    LePhotoTagEntity,
    vueDropzone: vue2Dropzone
  },
  props: {
    gameUuid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rotatePhotoLoading: false,
      photoTagsLoading: false,
      isLoading: true,
      photos: [],
      entityOptions: null,
      currentPhotoIndex: 0,
      currentPhotoTags: []
    }
  },
  created () {
    this.removeFileTimers = []
  },
  beforeDestroy () {
    this.removeFileTimers.forEach(timer => clearTimeout(timer))
  },
  mounted () {
    this.getPhotos()
    this.getEntityOptions()
  },
  computed: {
    currentClient () {
      return this.$store.state.currentClient
    },
    currentPhoto () {
      return this.photos[this.currentPhotoIndex]
    },
    dropzoneOptions () {
      return {
        url: `${process.env.VUE_APP_BASE_URL}api/photos`,
        autoProcessQueue: true,
        uploadMultiple: false,
        parallelUploads: 1,
        maxFilesize: 50,
        addRemoveLinks: true,
        headers: {
          'X-ORGANISATION': this.currentClient.uuid,
          Authorization: `Bearer ${TokenService.getToken()}`,
          Accept: '*'
        }
      }
    }
  },
  methods: {
    async prevPhoto () {
      if (this.currentPhotoIndex > 0) {
        this.photoTagsLoading = true
        this.currentPhotoIndex--
        await this.getPhotoTags(this.currentPhoto)
        this.photoTagsLoading = false
      }
    },
    async nextPhoto () {
      if (this.currentPhotoIndex < this.photos.length - 1) {
        this.photoTagsLoading = true
        this.currentPhotoIndex++
        await this.getPhotoTags(this.currentPhoto)
        this.photoTagsLoading = false
      }
    },
    togglePlayer (playerEntity, teamEntity) {
      const isSelected = this.isEntitySelected(playerEntity)

      if (!isSelected) {
        // Add player tag
        this.addTag(playerEntity)

        // Auto-add team tag if not already tagged
        if (!this.isEntitySelected(teamEntity)) {
          this.addTag(teamEntity)
        }
      } else {
        // Remove player tag
        this.removeTag(playerEntity)

        // Remove team tag if no other players from this team are still tagged
        const teamPlayers = this.entityOptions.homeTeam.entity.entityUuid === teamEntity.entityUuid
          ? this.entityOptions.homeTeam.players
          : this.entityOptions.awayTeam.players

        const otherTaggedPlayers = teamPlayers.filter(
          p => p.entity.entityUuid !== playerEntity.entityUuid && this.isEntitySelected(p.entity)
        )

        if (otherTaggedPlayers.length === 0 && this.isEntitySelected(teamEntity)) {
          this.removeTag(teamEntity)
        }
      }
    },
    addTag (entity) {
      PhotoService.addTag(this.currentPhoto.uuid, {
        entityUuid: entity.entityUuid,
        entityType: entity.entityType
      })
      this.currentPhotoTags.push({
        entityUuid: entity.entityUuid,
        entityType: entity.entityType
      })
    },
    removeTag (entity) {
      PhotoService.deleteTag(this.currentPhoto.uuid, {
        entityUuid: entity.entityUuid,
        entityType: entity.entityType
      })
      const tagIndex = this.currentPhotoTags.findIndex(tag => tag.entityUuid === entity.entityUuid)
      if (tagIndex !== -1) {
        this.currentPhotoTags.splice(tagIndex, 1)
      }
    },
    isEntitySelected (entity) {
      return this.currentPhotoTags.some(tag => tag.entityUuid === entity.entityUuid && tag.entityType === entity.entityType)
    },
    async editPhoto (photo, index) {
      this.photoTagsLoading = true
      this.currentPhotoIndex = index
      this.$modal.show('tags')
      await this.getPhotoTags(photo)
      this.photoTagsLoading = false
      window.addEventListener('keydown', this.onKeyPress)
    },
    modalClosed () {
      this.currentPhotoTags = []
      this.currentPhotoIndex = 0
      window.removeEventListener('keydown', this.onKeyPress)
    },
    onKeyPress (e) {
      if (e.code === 'ArrowLeft') {
        this.prevPhoto()
      } else if (e.code === 'ArrowRight') {
        this.nextPhoto()
      }
    },
    deletePhoto (photo, photoIndex) {
      PhotoService.delete(photo.uuid)
      this.photos.splice(photoIndex, 1)
    },
    toggleHighlight () {
      const photo = this.currentPhoto
      if (!photo || !photo.uuid) return
      const nextValue = !photo.isHighlighted
      if (this.$set) {
        this.$set(photo, 'isHighlighted', nextValue)
        this.$set(this.photos, this.currentPhotoIndex, { ...photo })
      } else {
        photo.isHighlighted = nextValue
        this.photos[this.currentPhotoIndex] = { ...photo }
      }

      PhotoService.updateIsHighlighted(photo.uuid, nextValue)
    },
    isHighlighted (photo) {
      if (!photo || !photo.uuid) return false
      return !!photo.isHighlighted
    },
    rotatePhoto (direction) {
      this.rotatePhotoLoading = true
      const photo = this.photos[this.currentPhotoIndex]
      PhotoService.rotate(photo.uuid, direction)
        .then(response => {
          this.photos[this.currentPhotoIndex] = response.data
          const photoElement = document.getElementById('photo-' + photo.uuid)
          const photoCoverElement = document.getElementById('photo-cover-' + photo.uuid)

          if (photoElement) {
            const url = new URL(photoElement.src)
            url.searchParams.set('v', Date.now())
            photoElement.src = url.toString()
          }

          if (photoCoverElement) {
            const url = new URL(photoCoverElement.src)
            url.searchParams.set('v', Date.now())
            photoCoverElement.src = url.toString()
          }
        }).finally(() => {
          this.rotatePhotoLoading = false
        })
    },
    async getPhotoTags (photo) {
      const response = await PhotoService.getTags(photo.uuid, 'game')
      this.currentPhotoTags = response.data
    },
    getEntityOptions () {
      PhotoService.getGameEntityOptions(this.gameUuid)
        .then(response => {
          this.entityOptions = response.data
        })
    },
    getPhotos () {
      this.isLoading = true
      PhotoService.index('game', this.gameUuid)
        .then(response => {
          this.photos = response.data
        })
        .catch(e => {
          console.log(e)
        }).finally(() => {
          this.isLoading = false
        })
    },
    moveUploadedFile (file, responseData) {
      const timer = setTimeout(() => {
        this.removeFileTimers = this.removeFileTimers.filter(t => t !== timer)

        if (file.status === 'success') {
          const photo = { ...responseData }
          if (photo.isHighlighted === undefined) {
            photo.isHighlighted = false
          }
          this.photos.push(photo)
        }

        if (this.$refs.dropzone) {
          this.$refs.dropzone.removeFile(file)
        }
      }, 1000)
      this.removeFileTimers.push(timer)
    },
    sendingEvent (file, xhr, formData) {
      formData.append('entityUuid', this.gameUuid)
      formData.append('entityType', 'game')
    }
  }
}
</script>

<style>
#dropzone-gallery {
    height: 270px;
    overflow: hidden;
    text-align: center;

  .dz-image img {
    object-fit: cover;
  }

  .gallery-modal-header {
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 2;
  }
}
.gallery-rotate-right-icon {
  transform: scaleX(-1)
}
</style>
